import Faq from '../components/Faq'
import BreedServices from '../components/BreedServices'
import NewsLetter from '../components/NewsLetter'
import ShopAreaCat from '../components/ourshop/ShopAreaCat';
import BreadCumbcat from '../components/shop/BreadCumb';
import ShopAll from '../components/ourshop/Shopall';
import { useEffect } from 'react';


function Shop() {
useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
}, []);


	return (

		<main>
			<BreadCumbcat/>
			<ShopAll />
			<BreedServices />
			<NewsLetter />
		</main>
	)
}

export default Shop;
